import React from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import CircularArcs from "../CircularArc";
import styled from "styled-components";
import { useApp } from "../../contexts/AppContext";

interface CycleData {
  cycle: string;
  eggs: string;
  liveBirth1: number;
  liveBirth2: number;
}

const StyledPaper = styled(Paper)(() => ({
  borderRadius: 2,
  backgroundColor: "white",
  ".MuiBox-root": {
    paddingLeft: 12,
    paddingRight: 12,
    marginBottom: 2,
    borderBottom: "1px solid #E5E5E5",
  },
}));

const CycleTable: React.FC<{ cycleData: CycleData[] }> = ({ cycleData }) => {
  const { translate } = useApp();
  const translations = translate("eggfreeze");
  return (
    <React.Fragment>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={2}>
          <Typography variant="report.info.label">
            {translations.report.estimatedResults.ifYouDo}
          </Typography>
        </Grid>
        <Grid item xs={4}></Grid>
        <Grid item xs={4}>
          <Typography variant="report.info.label">
            {translations.report.estimatedResults.liveBirthChance}
          </Typography>
        </Grid>
      </Grid>
      <Card elevation={1}>
        <CardContent>
          {cycleData.map((item, index) => (
            <Box key={index}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={2}>
                  <Typography variant="report.table.large" fontWeight="bold">
                    {item.cycle}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <CircularArcs
                    title={item.eggs}
                    unit={translate("general", "eggs")}
                    level={index + 1}
                    size={120}
                    titleFontSize={30}
                    unitFontSize={15}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Stack direction={"row"} gap={1} alignItems={"center"}>
                    <Typography variant="report.table.large" fontWeight="bold">
                      {item.liveBirth1}%
                    </Typography>
                    <Typography variant="report.card.info.normal">
                      {translations.report.estimatedResults.atLeastOneLiveBirth}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={3}>
                  <Stack direction={"row"} gap={1} alignItems={"center"}>
                    <Typography variant="report.table.large" fontWeight="bold">
                      {item.liveBirth2}%
                    </Typography>
                    <Typography variant="report.card.info.normal">
                      {
                        translations.report.estimatedResults
                          .atLeastTwoLiveBirths
                      }
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          ))}
        </CardContent>
      </Card>
    </React.Fragment>
  );
};

export default CycleTable;
